import React, { Component } from 'react';
import Modifydelivery from './modifydelivery';
/**
 * 修改快递单号
 */
export class ModifyDelivery extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { row, entity } = this.props;
        return (
            <div>
                <Modifydelivery rows={row} entity={entity} />
            </div>
        );
    }
}
